import React from "react";

export default function FaqAccordion({ section }) {
  if (!section?.items?.length) return null;
  return (
    <div>
      <span className="gw-eyebrow">FAQ</span>
      <h2 style={{maxWidth: 640}}>{section.heading}</h2>
      <div className="gw-faq" style={{marginTop: "var(--gw-space-6)"}}>
        {section.items.map((qa) => (
          <details key={qa.question}>
            <summary>
              <span>{qa.question}</span>
            </summary>
            <p>{qa.answer}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
